import { modifier } from 'ember-modifier';

export default modifier((element: HTMLElement, [action]: [(entered: boolean, event: MouseEvent) => void]) => {
  const mouseHandler = (entered: boolean, event: MouseEvent) => {
    const hasXOverflow = element.scrollWidth > element.clientWidth;

    if (hasXOverflow) {
      action(entered, event);
      return;
    }

    action(false, event);
  };

  const mouseDown = (event: MouseEvent) => {
    mouseHandler(true, event);
  };

  const mouseUp = (event: MouseEvent) => {
    mouseHandler(false, event);
  };

  element.addEventListener('mouseenter', mouseDown);
  element.addEventListener('mouseleave', mouseUp);

  return () => {
    element.removeEventListener('mouseenter', mouseDown);
    element.removeEventListener('mouseleave', mouseUp);
  };
});
